export const initialState = {
    userData:{},
    notificationMessage:'',
    notificationType:''
}